import { requestApi } from '../util/network'

// 获取用户订单列表
export const addInstantMessage =
(data) =>
  requestApi(
    '/member_instant_message/add',
    'POST',
      data,
    'member'
  )
